import { Avatar, AvatarGroup, Tooltip } from '@chakra-ui/react';

import { useWatchers } from '../hooks/requestWatcher/useWatchers';

type Props = {
  requestId?: number;
};

export const RequestActiveUsers = ({ requestId }: Props) => {
  const watchers = useWatchers(requestId);

  return (
    <Tooltip label={watchers?.join(', ')}>
      <AvatarGroup>
        {watchers?.map((val) => <Avatar name={val} size="xs" fontSize="xs" title={val} key={val} />)}
      </AvatarGroup>
    </Tooltip>
  );
};
